import React, { lazy, Suspense } from "react";
import { ERoutes, IRoute } from "./AppRouter.types";
import { FooterLayout } from "./layouts";

const lazyLoad = <T extends Record<string, React.ComponentType>>(
  importFn: () => Promise<T>,
  name: keyof T
) => lazy(() => importFn().then((m) => ({ default: m[name] })));

const SchedulePage = lazyLoad(
  () => import("../components/SchedulePage/SchedulePage"),
  "SchedulePage"
);
const TrainingPage = lazyLoad(
  () => import("../components/TrainingPage/TrainingPage"),
  "TrainingPage"
);
const MyTrainingsPage = lazyLoad(
  () => import("../components/MyTrainingsPage/MyTrainingsPage"),
  "MyTrainingsPage"
);
const AuthorizationPage = lazyLoad(
  () => import("../components/AuthorizationPage/AuthorizationPage"),
  "AuthorizationPage"
);
const SettingsPage = lazyLoad(
  () => import("../components/SettingsPage/SettingsPage"),
  "SettingsPage"
);
const ProfilePage = lazy(() =>
  import("../components/ProfilePage/ProfilePage").then((m) => ({
    default: m.ProfilePage,
  }))
);
const FiltersPage = lazyLoad(
  () => import("../components/FiltersPage/FiltersPage"),
  "FiltersPage"
);
const TrainingFilter = lazyLoad(
  () => import("../components/FiltersPage/TrainingFilter"),
  "TrainingFilter"
);
const TrainerFilter = lazyLoad(
  () => import("../components/FiltersPage/TrainerFilter"),
  "TrainerFilter"
);
const TimeFromFilter = lazyLoad(
  () => import("../components/FiltersPage/TimeFromFilter"),
  "TimeFromFilter"
);
const ClubFilter = lazyLoad(
  () => import("../components/FiltersPage/ClubFilters"),
  "ClubFilter"
);
const FreezePage = lazyLoad(
  () => import("../components/FreezePage/FreezePage"),
  "FreezePage"
);
const SupportPage = lazyLoad(
  () => import("../components/SupportPage/SupportPage"),
  "SupportPage"
);
const ErrorPage = lazyLoad(
  () => import("../components/ErrorPage/ErrorPage"),
  "ErrorPage"
);
const ShoppingPage = lazyLoad(
  () => import("../components/ShoppingPage/ShoppingPage"),
  "ShoppingPage"
);
const PaymentSuccessfulPage = lazyLoad(
  () => import("../components/PaymentStatusPages/PaymentSuccessfulPage"),
  "PaymentSuccessfulPage"
);
const PaymentErrorPage = lazyLoad(
  () => import("../components/PaymentStatusPages/PaymentErrorPage"),
  "PaymentErrorPage"
);
const RegisterPage = lazyLoad(
  () => import("../components/RegisterPage/RegisterPage"),
  "RegisterPage"
);
const ShoppingCartPage = lazyLoad(
  () => import("../components/ShoppingCartPage/ShoppingCartPage"),
  "ShoppingCartPage"
);
const MessagesList = lazyLoad(
  () => import("../components/SupportPage/MessagesList"),
  "MessagesList"
);
const CreateSupportMessage = lazyLoad(
  () => import("../components/SupportPage/CreateSupportMessage"),
  "CreateSupportMessage"
);
const OtpPage = lazy(() => import("../components/AuthorizationPage/OtpPage"));

const PageFallback = () => <div>Загрузка...</div>;

const wrapLazy = (LazyComponent: React.LazyExoticComponent<React.ComponentType>) => (
  <Suspense fallback={<PageFallback />}>
    <LazyComponent />
  </Suspense>
);

export const AuthorizedRoutes: IRoute[] = [
  {
    path: ERoutes.MAIN,
    element: wrapLazy(SchedulePage),
    layout: FooterLayout,
  },
  {
    path: ERoutes.SCHEDULE,
    element: wrapLazy(SchedulePage),
    layout: FooterLayout,
  },
  {
    path: ERoutes.FREEZE,
    element: wrapLazy(FreezePage),
  },
  {
    path: ERoutes.SUPPORT,
    element: wrapLazy(SupportPage),
  },
  {
    path: ERoutes.MESSAGES_LIST,
    element: wrapLazy(MessagesList),
  },
  {
    path: ERoutes.NEW_TICKET,
    element: wrapLazy(CreateSupportMessage),
  },
  {
    path: ERoutes.PROMOS,
    element: wrapLazy(SchedulePage),
  },
  {
    path: ERoutes.TRAINING_PAGE,
    element: wrapLazy(TrainingPage),
  },
  {
    path: ERoutes.MY_TRAININGS,
    element: wrapLazy(MyTrainingsPage),
    layout: FooterLayout,
  },
  {
    path: ERoutes.SETTINGS,
    element: wrapLazy(SettingsPage),
  },
  {
    path: ERoutes.PROFILE,
    element: wrapLazy(ProfilePage),
  },
  {
    path: ERoutes.FILTERS,
    element: wrapLazy(FiltersPage),
  },
  {
    path: ERoutes.TRAININGFILTER,
    element: wrapLazy(TrainingFilter),
  },
  {
    path: ERoutes.TIMEFROMFILTER,
    element: wrapLazy(TimeFromFilter),
  },
  {
    path: ERoutes.TRAINERFILTER,
    element: wrapLazy(TrainerFilter),
  },
  {
    path: ERoutes.CLUB_FILTER,
    element: wrapLazy(ClubFilter),
  },
  {
    path: ERoutes.ERROR,
    element: wrapLazy(ErrorPage),
  },
  {
    path: ERoutes.REGISTER,
    element: wrapLazy(RegisterPage),
  },
  {
    path: ERoutes.SHOPPING,
    element: wrapLazy(ShoppingPage),
  },
  {
    path: ERoutes.PAYMENTSUCCESSFUL,
    element: wrapLazy(PaymentSuccessfulPage),
  },
  {
    path: ERoutes.PAYMENTERROR,
    element: wrapLazy(PaymentErrorPage),
  },
  {
    path: ERoutes.SHOPPINGCART,
    element: wrapLazy(ShoppingCartPage),
  },
];

export const UnauthorizedRoutes: IRoute[] = [
  {
    path: ERoutes.MAIN,
    element: wrapLazy(AuthorizationPage),
  },
  {
    path: ERoutes.REGISTER,
    element: wrapLazy(RegisterPage),
  },
  {
    path: ERoutes.OTP,
    element: wrapLazy(OtpPage),
  },
  {
    path: ERoutes.SHOPPING,
    element: wrapLazy(ShoppingPage),
  },
  {
    path: ERoutes.PAYMENTSUCCESSFUL,
    element: wrapLazy(PaymentSuccessfulPage),
  },
  {
    path: ERoutes.PAYMENTERROR,
    element: wrapLazy(PaymentErrorPage),
  },
  {
    path: ERoutes.SHOPPINGCART,
    element: wrapLazy(ShoppingCartPage),
  },
];
